module.exports = __webpack_public_path__ + "media/Video (3).d04b3be4.mp4";